function AppFooterCopyright() {
  return (
    <div className="font-general-regular flex justify-center items-center text-center">
      <div className="text-lg text-neutral-600">
        &copy; {new Date().getFullYear()}
        <a
          href="https://github.com/realstoman/react-tailwindcss-portfolio"
          target="_blank"
          rel="noopener noreferrer"
          className="ml-1 text-black duration-500 hover:underline"
        >
          React & Tailwind CSS Portfolio
        </a>
        .
      </div>
    </div>
  );
}

export default AppFooterCopyright;
